/**
 * PRODUCTION STORE
 */

import api from "Api";

const state = {
    page: {},
    production_line: null,
    production_lines: JSON.parse(localStorage.getItem("production_lines")) || null,
    production_lines_filter: {
        search: "",
        page_size: 0,
        page_num: 1,
    },
    production_station: null,
    production_stations: JSON.parse(localStorage.getItem("production_stations")) || null,
    production_stations_filter: {
        search: "",
        line_id: "",
        procedure_id: "",
        page_size: 0,
        page_num: 1,
    },
    production_procedure: null,
    production_procedures: JSON.parse(localStorage.getItem("production_procedures")) || null,
    production_procedures_filter: {
        search: "",
        line_id: "",
        page_size: 0,
        page_num: 1,
    },
};

// getters
const getters = {};

// actions
const actions = {
    async fetchProduction({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitProduction", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitProduction", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateProduction", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitProduction(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateProduction(state, payload) {
        if (payload.method == "post" && payload.with) {
            if (state[payload.property] == null) state[payload.property] = [];
            state[payload.property].push(payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == payload.with[payload.pk])];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            state[payload.property].splice(
                state[payload.property].findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
        }
    },
    resetProduction(state) {
        state.page = {};
        state.production_line = null;
        state.production_lines = JSON.parse(localStorage.getItem("production_lines")) || null;
        state.production_lines_filter = {
            search: "",
            page_size: 0,
            page_num: 1,
        };
        state.production_station = null;
        state.production_stations = JSON.parse(localStorage.getItem("production_stations")) || null;
        state.production_stations_filter = {
            search: "",
            line_id: "",
            procedure_id: "",
            page_size: 0,
            page_num: 1,
        };
        state.production_procedure = null;
        state.production_procedures = JSON.parse(localStorage.getItem("production_procedures")) || null;
        state.production_procedures_filter = {
            search: "",
            line_id: "",
            page_size: 0,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
